module.exports = __webpack_public_path__ + "img/responsible-citizen.b583a612.svg";